import { render, staticRenderFns } from "./IndexInfo.vue?vue&type=template&id=4c03f572&scoped=true&"
import script from "./IndexInfo.vue?vue&type=script&lang=js&"
export * from "./IndexInfo.vue?vue&type=script&lang=js&"
import style0 from "./IndexInfo.vue?vue&type=style&index=0&id=4c03f572&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c03f572",
  null
  
)

export default component.exports